// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"getstarted-module--iconContainer--2IHEk","container":"getstarted-module--container--1rqL3","wrapper":"getstarted-module--wrapper--R6AIH"};